import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "splide-wrapper" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "splide-controls" };
const _hoisted_5 = { class: "splide-pagination-custom" };
const _hoisted_6 = ["onClick"];
import { ref, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HeroCarousel',
    props: {
        slides: {}
    },
    setup(__props) {
        const props = __props;
        const splideRef = ref(null);
        const activeIndex = ref(0);
        const splideOptions = {
            type: 'loop',
            perPage: 1,
            arrows: false,
            pagination: false,
            autoplay: false,
            height: 'calc(100vh - 85px)',
            breakpoints: {
                768: {
                    height: 'calc(50vh - 85px)',
                }
            }
        };
        onMounted(() => {
            if (splideRef.value) {
                const splide = splideRef.value.splide;
                splide.on('moved', (newIndex) => {
                    activeIndex.value = newIndex;
                });
            }
        });
        const goNext = () => {
            if (splideRef.value) {
                splideRef.value.splide.go('>');
            }
        };
        const goPrev = () => {
            if (splideRef.value) {
                splideRef.value.splide.go('<');
            }
        };
        const goToSlide = (index) => {
            if (splideRef.value) {
                splideRef.value.splide.go(index);
            }
        };
        return (_ctx, _cache) => {
            const _component_SplideSlide = _resolveComponent("SplideSlide");
            const _component_Splide = _resolveComponent("Splide");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "fade-overlay fade-top" }, null, -1)),
                _createVNode(_component_Splide, {
                    options: splideOptions,
                    ref_key: "splideRef",
                    ref: splideRef
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(__props.slides), (slide, index) => {
                            return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", {
                                        src: slide.image,
                                        alt: slide.image_alt
                                    }, null, 8, _hoisted_2)
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _: 1
                }, 512),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fade-overlay fade-bottom" }, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(__props.slides), (slide, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: index,
                                    class: _normalizeClass(['pagination-dot', { 'is-active': index === activeIndex.value }]),
                                    onClick: ($event) => (goToSlide(index))
                                }, null, 10, _hoisted_6));
                            }), 128))
                        ]),
                        _createElementVNode("div", { class: "splide-arrows" }, [
                            _createElementVNode("button", {
                                class: "splide-arrow splide-arrow--prev",
                                onClick: goPrev
                            }, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("svg", {
                                        width: "17",
                                        height: "30",
                                        viewBox: "0 0 17 30",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M15.6999 0.707092L1.41418 14.9928L15.6999 29.2785",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        })
                                    ], -1)
                                ]))]),
                            _createElementVNode("button", {
                                class: "splide-arrow splide-arrow--next",
                                onClick: goNext
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("svg", {
                                        width: "17",
                                        height: "30",
                                        viewBox: "0 0 17 30",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M0.707082 0.707092L14.9928 14.9928L0.707082 29.2785",
                                            stroke: "currentColor",
                                            "stroke-width": "2"
                                        })
                                    ], -1)
                                ]))])
                        ])
                    ])
                ])
            ]));
        };
    }
});
